import script from "./HomeButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeButton.vue?vue&type=script&setup=true&lang=ts"

import "./HomeButton.vue?vue&type=style&index=0&id=a9bbb1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9bbb1c4"]])

export default __exports__